<template>
  <header class="min-h-18 flex items-center pl-5 bg-gray-300">
    <user-info :user="userData">
      <span class="">{{ partialEmail }}&nbsp;</span>
    </user-info>
    <lm-icon-button
      icon="close"
      class="ml-auto pr-4"
      svg
      @click="$emit('close')"
    />
  </header>
</template>

<script>
import LmIconButton from '@/components/ui/LmIconButton'
import UserInfo from '@/components/landscape/topics/UserInfo'
import {mapGetters} from 'vuex'

export default {
  name: 'SidenavHeader',
  components: {LmIconButton, UserInfo},
  computed: {
    ...mapGetters(['userData']),
    partialEmail() {
      return this.userData.email.replace(
        /(\w{2})[\w.-]+@([\w.]+\w)/,
        '$1***@$2'
      )
    }
  }
}
</script>
